export const getCurrentPageInfo = ({
  currentPage,
  fetchLimit,
  currentPageItemsCount,
  totalItemsCount,
}: {
  currentPage: number;
  fetchLimit: number;
  currentPageItemsCount: number;
  totalItemsCount: number;
}) => {
  return `Showing ${(currentPage - 1) * fetchLimit + 1}-${
    (currentPage - 1) * fetchLimit + currentPageItemsCount
  } of ${totalItemsCount}`;
};

export const getTotalPagesCount = ({
  totalItemsCount,
  fetchLimit,
}: {
  totalItemsCount: number;
  fetchLimit: number;
}) => {
  return Math.ceil(totalItemsCount / fetchLimit);
};
